// Utils/APIService.js
class APIService {
    constructor() {
        // Dynamically set base URL based on current host
        const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

        this.baseURL = isLocalhost ? "http://localhost:27742" : "https://biziverse.com";

        this.qikERP = isLocalhost ? "http://localhost:7220" : "https://qikerp.com";

        // API endpoints
        this.endpoints = {
            external: {
                getLdInfoNoM: '/External.asmx/getLdInfoNoM',
                setLeadFdbkWsp: '/External.asmx/setLeadFdbkWsp',
                setDemoBookingWsp: '/External.asmx/setDemoWsp',
                signupCallback: '/External.asmx/signupCallback',
            },
            access: {
                sendOTP: '/WebService.asmx/sendOTP'
            },
        };
    }

    getHostBaseURL() {
        if (typeof window !== 'undefined' && window.location) {
            const protocol = window.location.protocol;
            const host = window.location.host;
            return `${protocol}//${host}`;
        }
    }

    getBaseUrl() {
        return this.baseURL;
    }

    // Generic fetch method
    async fetchRequest(url, body) {
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json;charset=UTF-8' },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            return result;
        } catch (error) {
            console.error('API Error:', error);
            throw error;
        }
    }

    // External.asmx methods
    async getLeadInfo(mobile, o) {
        const url = `${this.baseURL}${this.endpoints.external.getLdInfoNoM}`;
        const body = { mobile, o };
        return this.fetchRequest(url, body);
    }

    // Access.asmx methods
    async sendOTP(mobile, email = '', source = 'QikERP_Web', bzParams = '[{"o":""}]') {
        const url = `${this.qikERP}${this.endpoints.access.sendOTP}`;
        const body = {
            MobielNo: mobile,
            IsIndia: 1,
            Email: email,
            source: source,
            bzParams: bzParams
        };
        return this.fetchRequest(url, body);
    }


    async setLeadFdbkWsp(mobile, o, feedbackText) {
        const url = `${this.baseURL}${this.endpoints.external.setLeadFdbkWsp}`;
        const myParams = JSON.stringify({ mobile, o, feedbackText });
        return this.fetchRequest(url, { myParams });
    }
    async setDemoBookingWsp(mobile, o, bookingData) {
        const url = `${this.baseURL}${this.endpoints.external.setDemoBookingWsp}`;
        const myParams = JSON.stringify({ mobile, o, bookingData });
        return this.fetchRequest(url, { myParams });
    }

    async sendCallbackReqGuide({ mobile, question, companyName, name, eml, business, useSoftware }) {
        const url = `${this.baseURL}/External.asmx/sendCallBackReqGuide`;
        return this.fetchRequest(url, {
            mobile: mobile || '',
            question: question || '',
            companyName: companyName || '',
            name: name || '',
            eml: eml || '',
            business: business || '',
            useSoftware: useSoftware || ''
        });
    }

    async sendCallbackRequest({ name, company, mobile, notes }) {
        const isQikERP = window.location.hostname.includes('qikerp.com');
        const url = isQikERP
            ? `${this.getHostBaseURL()}/WebService.asmx/signupCallback`
            : `${this.baseURL}${this.endpoints.external.signupCallback}`;
        return this.fetchRequest(url, {
            aid: 0,
            uid: 0,
            eid: 0,
            contact: name,
            comp: company,
            mob: mobile,
            eml: '',
            src: '',
            jdt: '',
            note: notes || '',
            ind: '',
            seg: '',
            source: 'Website'
        });
    }

    async sendCallSensorReq(actionID, actionTxt, sensorOptions = {}) {
        const { leadPIN = '', mobile = '', xplor = '0', ofrStart = false, x = '', device = 'D' } = sensorOptions;
        const dynParams = JSON.stringify([{ leadPIN, mobile, actionID, actionTxt, xplor, ofrStart, x, device }]);
        const url = `${this.baseURL}/Access.asmx/act`;
        return this.fetchRequest(url, { dynParams });
    }
}

const apiService = new APIService();
export default apiService;